import { SearchRounded } from '@mui/icons-material';
import { Grid, OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import EventCard from '../../components/legacy/EventCard';
import { rtGetListData } from '../../store/slices/listSlice';

export default function EventScreen() {
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { events, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('events', 'events'));
    }, [dispatch]);

    return (
        <Screen loading={busy['events']} title="Events">
            <Grid item xs={12}>
                <OutlinedInput
                    value={search}
                    startAdornment={<SearchRounded className="me-2" />}
                    fullWidth
                    placeholder="Type to search"
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Grid>
            {events
                ?.filter((event) =>
                    JSON.stringify(event)
                        ?.toLowerCase()
                        .includes(search?.toLowerCase())
                )
                .map((event) => (
                    <EventCard
                        key={`${event?.id}`}
                        id={event?.id}
                        name={event?.name}
                        venue={event?.venue}
                        desc={event?.description}
                        date={event?.date}
                        time={event?.time.start}
                        reminder={event?.reminder}
                        event
                    />
                ))}
            {!busy['events'] && events?.length < 1 && <ListEmpty />}
        </Screen>
    );
}
